import { FC, useState } from "react";

import { CollaboratorRole } from "./../../../store/collaborators/types";
import { IconTypes } from "./../../../libs/Icon";
import Button from "./../../../libs/Button";
import Dropdown from "./../Dropdown";

import styles from "./styles.module.scss";

const Footer: FC = () => {
    const [currentRole, setCurrentRole] = useState<CollaboratorRole>(CollaboratorRole.Editor);

    const onChange = (newValue: CollaboratorRole) => {
        setCurrentRole(newValue);
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.share}>
                <p>Share a link to </p>

                <Dropdown
                    text={currentRole === CollaboratorRole.Editor ? "edit" : "view"}
                    isFooter
                    className={styles.variant}
                    currentRole={currentRole}
                    onChange={onChange}
                />
            </div>

            <Button icon={IconTypes.DUPLICATE} iconSize={20} className={styles.copy} />
        </footer>
    );
};

export default Footer;
